import { createFileRoute, redirect } from '@tanstack/react-router';

import { redirectToVehicles } from './-redirect';

/**
 * Legacy path, child routes (`/new`, `/:vehicleId`). Splat so every descendant
 * of the old prefix lands on its counterpart under `/fleet-management/vehicles`.
 */
export const Route = createFileRoute('/_app/fleet-management/digital-vehicle-files/$')({
  beforeLoad: ({ location }) => {
    throw redirect(redirectToVehicles(location.href));
  },
});
